<template>
    <div class="ssqOrdlt">
        <div class="tit">
            <div>
                <span style="font-size: 17px;font-weight: bold;">双色球最新开奖公告(第{{db[0] && db[0].cycle}}期] </span>
                <span style="font-size: 12px;" v-if="db[0]"> {{db[0].openTimestamp | handle_ymd}} ({{db[0].openTimestamp | handle_week}})开奖 </span>
            </div>
            <a href="https://caipiao.ip138.com/shuangseqiu/ "
               target="_blank"
               style="text-decoration: none;color:#fff">
                <span>更多</span>
            </a>
        </div>
        <div class="intro"
             v-if="db.length">
            投注总额: {{db[0].saleMoney}}元
            奖池金额: {{db[0].remainMoney}}元
        </div>
        <div class="table"
             v-if="db.length">
            <div>
                <div class="tit">红色球</div>
                <div class="num">
                    <span v-for="(item,index) in $_.split(db[0].openNbr,' ',6)"
                          :key="index">{{item}}</span>
                </div>
            </div>
            <div>
                <div class="tit">蓝色球</div>
                <div class="num">
                    <span>{{$_.slice($_.split(db[0].openNbr,' '),6,7)[0]}}</span>
                </div>
            </div>
        </div>
        <div class="table1"
             v-if="db.length">
            <div>
                <span>期号</span>
                <span>中奖条件</span>
                <span>中奖注数</span>
                <span>投注奖额</span>
            </div>
            <div v-for="(item, index) in list"
                 :key="index">
                <span>{{item.award}}</span>
                <span>{{item.ruler}}</span>
                <span>{{item.awardNbr}}</span>
                <span>{{item.simpleAwardMoney}}</span>
            </div>
        </div>
        <!-- <div class="intro">
            出球顺序:{{$_.split(db.openNbr,' ',6).toString()}} + {{$_.slice($_.split(db.openNbr,' '),6,7)[0]}}
        </div> -->
        <a href="https://caipiao.ip138.com/shuangseqiu/ "
           target="_blank"
           style="text-decoration: none;">
            <div class="sub">双色球返奖比例历史记录》</div>
        </a>

    </div>
</template>

<script>
export default {
    data () {
        return {
            db: {},
            list: [],
        }
    },
    filters: {
        handle_ymd (timestamp) {
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        handle_week (timestamp) {
            const date = new Date(timestamp * 1000);
            const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            return weekdays[date.getDay()];
        }
    },
    mounted () {
        this.getdb()
    },
    methods: {
        getdb () {
            let lotteryType = 0

            // 开奖基本信息
            this.$http.get('/stage-api/pre/record/forecast/runBaseLottery?type=' + lotteryType).then(res => {
                // console.log('ssq runBaseLotteryres',JSON.parse(JSON.stringify(res.data)));
                this.db = res.data
                this.db.front_week = this.$utils.timestampToWeekday(res.data.openTimestamp * 1000)
                this.db.front_ymd = this.$utils.timestampToYMD(res.data.openTimestamp * 1000)

                // res.data.cycle = 2023065
                // 奖等列表
                this.$http.get('/stage-api/pre/record/forecast/runLottery?type=' + lotteryType + '&cycle=' + res.data[0].cycle).then(res => {
                    // console.log('ssq list',JSON.parse(JSON.stringify(res)));
                    this.list = res.rows
                })
            })


        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/commonStyle.scss';
.ssqOrdlt {
    font-size: 14px;
    > .tit {
        display: flex;
        justify-content: space-between;
        margin: 0px 0 10px;
        background-color: $theme_color;
        padding: 10px;
        color: #ffffff;
    }
    .table {
        margin-top: 10px;
        text-align: center;
        font-size: 16px;
        display: flex;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        > div {
            .tit {
                background-color: $theme_color;
                color: #ffffff;
                padding: 5px;
            }
            &:first-child {
                flex: 6;
                border-left: 1px solid rgba(0, 0, 0, 0.2);
                .num {
                    display: flex;
                    span {
                        padding: 5px 0;
                        display: inline-block;
                        border-right: 1px solid rgba(0, 0, 0, 0.2);
                        width: 17%;
                        color: red;
                        font-weight: bold;
                    }
                }
            }
            &:last-child {
                flex: 2;
                .num {
                    padding: 5px 0;
                    border-right: 1px solid rgba(0, 0, 0, 0.2);
                    span {
                        color: blue;
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .table1 {
        text-align: center;
        margin-top: 5px;
        font-size: 12px;
        border-left: 1px solid rgba(0, 0, 0, 0.2);
        > div {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            span {
                border-right: 1px solid rgba(0, 0, 0, 0.2);
                padding: 5px 0;
                &:last-child {
                    color: red;
                    font-weight: bold;
                }
            }
            &:nth-child(1) {
                background-color: $theme_color;
                color: #ffffff;
                font-size: 16px;
                span {
                    color: unset;
                }
            }
        }
    }
    .intro {
        margin-top: 10px;
    }
    .sub {
        text-align: right;
        color: red;
        margin-top: 10px;
    }
}
</style>
